import { render, staticRenderFns } from "./ViewConsentForm.vue?vue&type=template&id=ae87bbd8&"
import script from "./ViewConsentForm.vue?vue&type=script&lang=js&"
export * from "./ViewConsentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports